import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { baseVariations } from '../Loader/constants';
import { BaseLoader, } from '../Loader/Loader.base';
import { sizes, } from './constants';
const buttonLoaderStyles = {
    destructive: {
        strokeBackgroundColor: theme.colors.negative600,
        strokeColor: theme.colors.gray100,
    },
    destructiveSecondary: {
        strokeBackgroundColor: theme.colors.negative200,
        strokeColor: theme.colors.negative800,
    },
    primary: baseVariations['light'],
    secondary: baseVariations['dark'],
    tertiary: baseVariations['dark'],
};
const containerSizes = {
    large: 24,
    medium: 24,
    small: 16,
};
const iconContainerStyles = css `
  position: absolute;
`;
const defaultProps = {
    loading: false,
    size: sizes.medium,
};
const LoadingSpinner = ({ loading = defaultProps.loading, size = defaultProps.size, type, }) => {
    const containerStyles = useMemo(() => (css `
        height: ${styleUtils.rem(containerSizes[size])};
        width: ${styleUtils.rem(containerSizes[size])};
      `), [
        size,
    ]);
    return (loading
        ? (_jsx("span", Object.assign({ css: iconContainerStyles }, { children: _jsx(BaseLoader, { css: containerStyles, strokeBackgroundColor: buttonLoaderStyles[type].strokeBackgroundColor, strokeColor: buttonLoaderStyles[type].strokeColor, type: "indeterminate" }) })))
        : null);
};
const MemoizedLoadingSpinner = memo(LoadingSpinner);
export { MemoizedLoadingSpinner as LoadingSpinner };
